import CreditModal from './CreditModal';

export default CreditModal;
